import React from 'react';
import Button from '../buttons/Button';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

function FormSubmit({ text, ...props }) {
  const { t } = useTranslation();
  return (
    <Button
      theme={classNames(['submit'], props.theme)}
      url={props.url}
      onPress={props.onPress}
      ariaLabel={props.ariaLabel}
      iconType={'chevron-right'}
      iconPosition={'right'}
      className={classNames(['form__button-submit', 'js-form-submit', 'form-submit'], props.className)}
      isDisabled={props.isDisabled}
      spinner={props.spinner}
    >
      {props.children || t('styleguide:forms.submit')}
    </Button>
  );
}

export default FormSubmit;
